import { render, staticRenderFns } from "./PreparingOTS.vue?vue&type=template&id=0d947868&scoped=true"
import script from "./PreparingOTS.vue?vue&type=script&lang=js"
export * from "./PreparingOTS.vue?vue&type=script&lang=js"
import style0 from "./PreparingOTS.vue?vue&type=style&index=0&id=0d947868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d947868",
  null
  
)

export default component.exports